import axios from 'axios';
  

const headers = {'Accept': 'application/json','Content-Type': "multipart/form-data"}

export const  axios_equipement_modify = async (datas)=>{
    return await axios.post("/equipement/modify", datas,{headers:headers});
}

export const  axios_equipement_create = async (datas)=>{
    return await axios.post("/equipement/create", datas,{headers:headers});
}

export const  axios_equipement_findbyIdlead = async (id_lead)=>{
    return await axios.post(`/equipement/findbyIdlead/`,{id_lead},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
}